import React from 'react'
import {useTheme} from '@material-ui/core/styles'
import './NotFound.scss'

const NotFound: React.FC<any> = (props: any) => {
    const theme = useTheme()
    return (
        <div id="notfound">
            <div className="notfound">
                <div className="notfound-404">
                    <h1 style={{ color: theme.palette.primary.main }} >404</h1>
                </div>
                <h2>Oops! Nothing was found</h2>
                <p><a href="/" style={{ color: theme.palette.primary.main }} >Return to homepage</a></p>
            </div>
        </div>
    )
}

export default NotFound
